module.exports = __webpack_public_path__ + "img/vilseck_ausst_2017_ref.7a4e79fb.jpg";